import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors } from '@angular/forms';
import { FileExplorerService } from '../file-explorer.service';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

interface CurrentItemInfo {
  name: string;
  isFile: boolean;
}

@Directive({
    selector: '[fileNameAlreadyExistsValidator]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: FileNameAlreadyExistsValidator, multi: true }
    ],
    standalone: false
})
export class FileNameAlreadyExistsValidator extends BaseValidator {

  private _current: CurrentItemInfo;

  @Input()
  public get fileNameAlreadyExistsValidator(): CurrentItemInfo {
    return this._current;
  }

  public set fileNameAlreadyExistsValidator(value: CurrentItemInfo) {
    this._current = value;
    if (this._onChange) this._onChange();
  }

  constructor(private fileExplorerService: FileExplorerService) {
    super('fileNameAlreadyExists');
  }

  protected getValidationResult(control: AbstractControl): ValidationErrors {

    if(!control.value)
      return null;

    if (this._current && this._current.name && control.value === this._current.name)
      return null;

    if(this.checkItemAlreadyExists(control.value)) {
      return this.buildValidationErrorResult({});
    }

    return null;
  }

  private checkItemAlreadyExists(value: string) {
    let selectedEl = this.fileExplorerService.selected;

    if (!selectedEl)
      return false;

    const isExists = selectedEl.children.find(x => {

      if (this._current) {

          return this._current.isFile ? 
              x.type === 'file' && x.name.toLowerCase() === value :
              x.type === 'dir' && x.name.toLowerCase() === value;        
      }
      else {
        return x.name.toLowerCase() == value;
      }
    });

    return isExists;
  }
}
